// Types
import { Icon } from 'leaflet';
import { AnglerId } from '../../types';

export interface IBaseData {
  anglerId: AnglerId;
  markerId: string;
  position: IMarkerPosition;
  rank: number;
}

export type IMarkerPosition = [number, number];

export interface ICatch extends IBaseData {
  fishWeightOz: number;
  fishWeightPdsOz: string;
  time: string;
}

export interface ILocation extends IBaseData {
  anglerName: string;
  lastLocationTime: string;
  sumFish: number;
  sumPdsOz: string;
}

export interface IMarker extends IBaseData {
  anglerName?: string;
  fishWeightOz?: number;
  fishWeightPdsOz?: string;
  lastLocationTime?: string;
  showCatchesDiv?: boolean;
  sumFish?: number;
  sumPdsOz?: string;
  time?: string;
}

export interface IPopupMarker extends IMarker {
  // Leaflet icon type.
  icon: Icon;
}

export interface IMarkerList {
  [key: string]: ISvgList;
}

export interface ISvgList {
  [key: string]: string;
}

export enum LayerType {
  CATCHES = 'catches',
  LOCATIONS = 'locations',
}

export enum IconType {
  BOAT = 'boat',
  FISH = 'fish',
}

export enum FilterType {
  ALL = 'all',
  TOP_12 = 'top12',
  ANGLER = 'angler',
}

export enum FilterLabel {
  ALL = 'All',
  TOP_12 = 'Top 12',
  ANGLER = 'Angler',
}

export enum NavFilterId {
  ANGLER_SELECT = 'angler-select',
}
